import type { CSSProperties } from 'react';

import styles from './Skeleton.module.scss';

type SkeletonProps = {
  readonly width?: number | string;
  readonly height?: number | string;
  readonly circle?: boolean;
  readonly className?: string;
  readonly style?: CSSProperties;
};

export function Skeleton({ width, height, circle = false, className, style }: SkeletonProps) {
  const classes = [styles.skeleton, circle ? styles.circle : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <span
      className={classes}
      style={{
        width,
        height,
        ...style,
      }}
    />
  );
}
